export default __webpack_public_path__ + "static/media/15e034ef839cad27ee88eeb3f93fb742.svg";